import React, { useState, useEffect, useRef } from "react";
import { Chart, ChartWrapperOptions } from "react-google-charts";
import { Loader } from "../../atoms/loader";

interface PieChartProps {
  data: any[];
  options: ChartWrapperOptions["options"];
  isLoading?: boolean;
  isFetching?: boolean;
}

export const PieChart = ({
  data,
  options,
  isLoading,
  isFetching = false,
}: PieChartProps) => {
  const [chartSize, setChartSize] = useState({ width: 0, height: 0 });
  const [chartKey, setChartKey] = useState(0);
  const chartContainerRef = useRef<HTMLDivElement>(null); // Reference to the chart container

  useEffect(() => {
    const chartContainer = chartContainerRef.current;

    const resizeObserver = new ResizeObserver(() => {
      if (chartContainer) {
        setChartSize({
          width: chartContainer.offsetWidth,
          height: chartContainer.offsetHeight,
        });
        setChartKey((prevKey) => prevKey + 1); // Force re-render with updated size
      }
    });

    if (chartContainer) {
      resizeObserver.observe(chartContainer);
    }

    // Clean up observer on component unmount
    return () => {
      if (chartContainer) {
        resizeObserver.unobserve(chartContainer);
      }
    };
  }, []);

  return (
    <div ref={chartContainerRef} className="m-chart">
      {isLoading ? (
        <div className="m-chart__skelton"></div>
      ) : (
        <Loader isLoading={isFetching}>
          <Chart
            key={chartKey}
            chartType="PieChart"
            data={data}
            options={options}
            width={chartSize.width}
            height={chartSize.height}
          />
        </Loader>
      )}
    </div>
  );
};
